module.exports = __webpack_public_path__ + "static/media/activate-user-banner.5541dce9.png";